define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/indexOf.js
// module id = 192
// module chunks = 0